import type { PatientStrings } from '../index';

export const bn: PatientStrings = {
  titleOne: 'আপনার নতুন ক্রাউন',
  titleMany: 'আপনার নতুন ক্রাউনগুলি',
  tooth: 'দাঁত',
  teeth: 'দাঁত',
  both: 'দুটোই',
  overview: 'পুরো দৃশ্য',
  front: 'সামনে থেকে',
  leftSide: 'বাঁ দিক',
  rightSide: 'ডান দিক',
  bitingSurface: 'চিবানোর দিক',
  show: 'দেখান',
  newCrown: 'নতুন ক্রাউন',
  newCrowns: 'নতুন ক্রাউনগুলি',
  yourTeeth: 'আপনার দাঁত ও মাড়ি',
  upperTeeth: 'উপরের দাঁত',
  lowerTeeth: 'নিচের দাঁত',
  hint: 'ঘোরাতে টানুন · জুম করতে পিঞ্চ বা স্ক্রোল করুন',
  zoomIn: 'কাছে আনুন',
  zoomOut: 'দূরে নিন',
  turnSlowly: 'ধীরে ঘোরান',
  stopTurning: 'ঘোরানো থামান',
  backToStart: 'শুরুতে ফিরুন',
  fullScreen: 'পূর্ণ স্ক্রিন',
  exitFullScreen: 'পূর্ণ স্ক্রিন থেকে বেরোন',
  fromDentist: 'আপনার দন্ত চিকিৎসকের কাছ থেকে',
  shadeNote: (shade) =>
    `রং মোটামুটি শেড ${shade}-এর মতো দেখানো হয়েছে। আসল ক্রাউনের রং ল্যাবে মেলানো হয়।`,
  before: 'আগে',
  after: 'পরে',
  seeInRoom: 'আপনার ঘরে দেখুন',
  arNotSupported: 'ক্রাউনটি আপনার ঘরে দেখতে এই পেজটি ফোনে খুলুন।',
  appointmentTitle: 'ক্রাউন বসানোর অ্যাপয়েন্টমেন্ট',
  confirm: 'নিশ্চিত করুন',
  confirmed: 'নিশ্চিত হয়েছে — তখন দেখা হবে',
  anotherTime: 'অন্য সময় চান',
  anotherTimeSent: 'আপনার দন্ত চিকিৎসককে জানানো হয়েছে যে আপনার অন্য সময় দরকার।',
  language: 'ভাষা',
  largerText: 'বড় লেখা',
};
